import CustomDialog from "../CustomDialog";

function ConfirmationDialog({
  open,
  onClose,
  content,
  onSubmit,
  title,
  yesButtonText,
  noButtonText,
  customWidth,sx,
  actions,
}: {
  title?: string;
  open: boolean;
  onClose(): void;
  content: any;
  onSubmit(): void;
  yesButtonText?: string;
  noButtonText?: string;
  customWidth?: string;
  actions?: {
    content: string;
    variant: "text" | "contained";
    onClick: () => void;
    sx?: React.CSSProperties;
    disabled?:boolean
  }[];
  sx?:any
}) {
  return (
    <CustomDialog
      title={title ?? "confirm"}
      open={open}
      content={content}
      onClose={onClose}sx={sx}
      actions={
        actions ?? [
          {
            content: yesButtonText ?? "Yes",
            variant: "contained",
            onClick: onSubmit,
            sx: { width: customWidth ?? "80px" },
          },
          {
            sx: { width: customWidth ?? "80px" },
            content: noButtonText ?? "No",
            variant: "text",
            onClick: onClose,
          },
        ]
      }
    />
  );
}

export default ConfirmationDialog;
